"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import Fuse from 'fuse';

function filterOptionsByLabel(options, searchString, fuzzy = true, additionalKeys = []) {
  if (!searchString || typeof searchString !== "string") {
    return options;
  }
  return new Fuse(options, {
    shouldSort: true,
    keys: ["searchLabel", "label", ...additionalKeys],
    threshold: fuzzy ? 0.3 : 0
    // 0 = exact match, 1 = match all
  }).search(searchString.trim()).map(({ item }) => item);
}

export { filterOptionsByLabel };
